import { createSelector } from '@reduxjs/toolkit';
import type { Memory } from '@timelyapp/integration-cloud-api-spec';
import { EMPTY_ARRAY } from 'constants/defaults';
import { DateTime } from 'luxon';
import { getHourDraftDay } from 'redux/selectors/hours.draft.base';
import { getRouteSearchAsObject } from 'redux/selectors/routing';
import { getTicApiSlice } from './api-slice/tic.api.selector';
import { ticApi } from './api-slice/tic.apiSlice';

export const getTicMemoryDate = createSelector(
  [getHourDraftDay, getRouteSearchAsObject],
  (draftDate, route): string => {
    if (draftDate) return draftDate;
    // Normalize any URL `?date=` value to YYYY-MM-DD; non-ISO values
    // (e.g. ?date=today) produce a null toISODate() and fall through to now().
    const fromUrl = route.date ? DateTime.fromISO(route.date).toISODate() : null;
    return fromUrl ?? DateTime.now().toISODate()!;
  }
);

/**
 * Ref `tic.createApi.base.ts`
 */
export const getTimelyLegacyMemoriesRTKQueryBase = createSelector(
  [getTicApiSlice, getTicMemoryDate],
  (localState, date) => {
    // cache key uses _only date_, ref getTimelyLegacyMemories's 'serializeQueryArgs'.
    // so `exclude_tracker_entries: null` has zero impact on results.
    const query = { date, exclude_tracker_entries: null };
    return ticApi.endpoints.getTimelyLegacyMemories.select(query)({
      [ticApi.reducerPath]: localState,
    });
  }
);

export const getTimelyLegacyMemoriesAsTicMemories = createSelector(
  [getTimelyLegacyMemoriesRTKQueryBase],
  (getQuery): Memory[] => getQuery.data || EMPTY_ARRAY
);
